.container {
  margin-bottom: 16px;
}

.title {
  display: flex;
}

.formControl {
  width: 100%;
}

.formLabel {
  width: 100%;
}

.optionBox {
  display: flex;
  gap: 16px;
  padding-top: 16px;
  align-items: center;
}

.optionLabel {
  display: flex;
  gap: 8px;
}
